import React from 'react';
import styled, {css} from "styled-components"

const StyledBadge = styled.span`
  border-radius: 9px;
  min-width: 3rem;
  padding: 0 6px;
  margin-left: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  float: right;
  box-sizing: border-box;
  font-size: 1.3rem;
  
  ${({ stat }) => {
    const positiveStyles = css`
        background-color: #C3F3C5;
        border: 1px solid #C3F3C5;
        color: #065A3F;`
  
    const negativeStyles = css`
        background-color: #F8E0B4;
        border: 1px solid #F8E0B4;
        color: #902D12;`
  
    if (stat > 0) {
      return positiveStyles;
    } else {
      return negativeStyles;
    }
  }}
`

const Badge = ({stat=0, type}) => {
  return (
    <StyledBadge stat={stat}>
      {stat > 0 && '+'}{stat}%
    </StyledBadge>
  )
}

export default Badge;